import {
  Progress as AntProgress,
  ProgressProps as AntProgressProps
} from 'antd';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import { Typography } from '../../Typography';

export interface LoadingBarProps
  extends Pick<AntProgressProps, 'percent' | 'className'> {
  label?: string;
}

export const LoadingBar: React.FC<LoadingBarProps> = ({
  percent = 0,
  label,
  className
}) => (
  <Container className={className} data-testid="loading-bar">
    <AntProgress
      percent={percent}
      showInfo={false}
      size={['100%', 8]}
      strokeLinecap="round"
      strokeColor={theme.dime.colors.fill.brandPrimary}
      trailColor={theme.dime.colors.fill.secondary}
    />
    <Step>
      {label ? (
        <StepText
          variant="body1"
          color={theme.dime.colors.text.secondary}
          data-testid="loading-bar-label"
        >
          {label}
        </StepText>
      ) : null}
      <StepText
        variant="body1"
        color={theme.dime.colors.text.secondary}
        data-testid="loading-bar-percent"
      >
        {`${percent}%`}
      </StepText>
    </Step>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.dime.spacing.s};
  width: 100%;

  .ant-progress {
    line-height: 0;
  }
`;

const StepText = styled(Typography)`
  && {
    line-height: ${theme.dime.fonts.lineHeights.md};
  }
`;

const Step = styled.div`
  display: flex;

  > :last-child {
    margin-left: auto;
  }
`;
